// extracted by mini-css-extract-plugin
export var carrierIcon = "_v8-0";
export var carrierLogo = "_v8-1";
export var detailsSection = "_v8-2";